import * as actionTypes from './actionTypes';

const axiosPayLoad = {
  override508Compliance: false,
  UserDefaultsValues: {
    // Plan Type
    planTypeCd: null,
    // Rebate Program
    rebateProgramCd: '-1',
    // Check Payee
    checkPayeeCd: '-1',
    // NDC Select Mode
    defNdcSelectModeCd: null,
    // Default Report Quarter Option
    defRptQtrSelectCd: null,
    // Default Invoice Select Mode
    defInvoiceSelectModeCd: null,
    // Quarter A/R Invoice Balance
    dispBalanceDueInvInd: 0,
    dispOverriddenInvInd: 0,
    dispPaidInFullInvInd: 0,
    // A/R NDC Balance Defaults:
    dispBalanceDueNdcInd: 0,
    dispOverriddenNdcInd: 0,
    dispPaidInFullNdcInd: 0,
    // Account:
    viewPmtActInd: 0,
    viewIntActInd: 0,
    // Client
    clientId: '-1',
    // Group
    groupId: '-1',
    // Plan
    planId: '',
  },
  rebateProgramCode: [],
  clientCode: [],
  planCode: [],
  groupCode: [],
  checkPayeeCode: [],
  update: {
    message: '',
    status: '',
    data: null,
    timestamp: null,
  },
  validateCheckPayee: {
    data: null,
    message: null,
    status: null,
    timestamp: null,
  },
  tabChanges: {
    values: null,
    isUserChangedValue: null,
  },
};

const reducer = (state = axiosPayLoad, action) => {
  switch (action.type) {
    case actionTypes.GET_USER_DEFAULTS:
      return { ...state, UserDefaultsValues: action.UserDefaultsValues };
    case actionTypes.GET_ALL_REBATE_PROGRAMS:
      return {
        ...state,
        rebateProgramCode:
          action.rebateProgramCode && action.rebateProgramCode.data
            ? action.rebateProgramCode.data
            : [],
      };
    case actionTypes.GET_ALL_CLIENT_CODE:
      return { ...state, clientCode: action.clientCode };
    case actionTypes.GET_ALL_PLAN:
      return { ...state, planCode: action.planCode };
    case actionTypes.GET_ALL_GROUP:
      return { ...state, groupCode: action.groupCode };
    case actionTypes.GET_CHECK_PAYEE:
      return { ...state, checkPayeeCode: action.checkPayeeCode };
    case actionTypes.UPDATE_USER_DEFALTS:
      return { ...state, update: action.update };
      case actionTypes.SET_OVERRIDE_508_COMPLIANCE:
        return {
          ...state,
          override508Compliance: action.payload,
        };
    case actionTypes.VALIDATE_CHECK_PAYEE:
      return { ...state, validateCheckPayee: action.validateCheckPayee };
    case actionTypes.GET_TAB_CHANGES:
      return { ...state, tabChanges: action.payload };
    default:
      return state;
  }
};

export default reducer;
